import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import PapeletaModal from './PapeletaModal'
import { resourcesUnits,resourcesPapeletas } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,Alert} from '../../../helpers/alerts/alertHelper';
import { getPolicyUser } from '../../../helpers/api_helper';
import {Container} from "reactstrap";
import { getStorageCompany,getStorageUser } from '../../../helpers/api_helper';
import PreviewPDF from '../../../helpers/previewPDF';
import ConfigModal from "./ConfigModal";


const Units = () => {
    const timeElapsed = new Date();
    const dateNow = `${timeElapsed.getFullYear()}-${timeElapsed.getMonth()+1 < 10 ? '0':''}${timeElapsed.getMonth()+1}-${timeElapsed.getDate()}`;
    const policy = getPolicyUser();
    const authUser = getStorageUser();
    const company = getStorageCompany();
    const [pending, setPending] = useState(false);
    const [date, setDate] = useState(dateNow);
    const [modal, setModal] = useState({show:false,update:false,papeleta:false, config: false});
    const [dataPag, setDataPag] = useState({total:0});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc',companySession:company.id});
    const [items, setItems] = useState([]);

    const dispatch = useDispatch()
    useEffect(() => {
        let params={params:filters}
        setPending(true)
        resourcesUnits('get',params).then(response => {
            setItems(response.data)
            setDataPag(response.meta)
            setPending(false)
        }
        )
    }, [filters])

    useEffect(() => {
        console.log(date)
    }, [date])

    const getReports = (id,type) => {  
        let config = type==3 ? {params:{type:type,date:date}}
        :
        {params:{type:type,date:date},headers:{'Accept': 'application/pdf'},responseType: "blob",}
        /*if(type!=3){
            resourcesPapeletas('file',config,id).then(response => {

            })
        }*/
        resourcesPapeletas('show',config,id).then(response => {
            if(type==3){
                setModal({show:false,papeleta:true,salidas:response.salidas,unidad:response.unidad,date:response.date});
            }else{
                let nombre = 'Archivo';
                var reader = new FileReader();
                reader.readAsDataURL(response);
                reader.fileName = nombre[1] || nombre[0];
                reader.onloadend = function (name) {
                    name = nombre[0];
                    var base64data = reader.result;
                    setModal({show:true,update:false,url:base64data});
            
                };
            }
        })
    }

    const columns = Columns(getReports);
	document.title = "Tablero de Papeletas | Sistema de logística";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper filterInp={false} tittle="Tablero de Papeletas" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                            <div className="col-sm-2">
                                    <label className="form-label">Fecha:</label>
                                    <input className="form-control" placeholder='Fecha' name="time" type="date" onChange={ e => setDate(e.target.value) } value={date}/>
                            </div>
                            <div className="col-sm-10 text-end">
                                <button
                                    className="btn btn-secondary btn-sm"
                                    title="Imprimir"
                                    onClick={() => setModal(prev => ({...prev, config: true}))}
                                >
                                    <i className="fa fa-wrench"></i>
                                </button>
                            </div>
                        </DataTableHelper>
                    </div>
                </Container>
                    {modal.show && (
                        <PreviewPDF modalPdf={modal} setModalPdf={setModal} />
                    )}
                    {modal.papeleta && (
                        <PapeletaModal modal={modal} setModal={setModal}/>  
                    )}
                    {modal.config && (
                        <ConfigModal modal={modal} setModal={setModal}/>  
                    )}
            </div>
        </React.Fragment>
    );
};

export default Units;